"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Platform", {
  enumerable: true,
  get: function () {
    return _consts.Platform;
  }
});
Object.defineProperty(exports, "UICookiePrefix", {
  enumerable: true,
  get: function () {
    return _consts.UICookiePrefix;
  }
});
exports.isWebview = exports.isTequila = exports.isIos = exports.isAndroid = exports.getPlatform = void 0;
var _cookies = require("@kiwicom/cookies");
var _shared = require("./shared");
var _consts = require("./consts");
/**
 * Client-side function that retrieves the platform based on the query parameter
 * "platform" or the UI cookie.
 *
 * A UI string is considered valid if it matches any of the UICookiePrefix
 * values or starts with any of the UICookiePrefix values followed by an underscore.
 *
 * This is to be backwards compatible with values such as `android_abtest` or
 * `ios_abtest` that were previously used.
 *
 * @returns The platform enum value.
 */
const getPlatform = () => {
  var _query$get;
  const query = new URLSearchParams(window.location.search);
  const ui = (_query$get = query.get("platform")) !== null && _query$get !== void 0 ? _query$get : (0, _cookies.load)(_cookies.Cookie.UI);
  return (0, _shared.getPlatform)({
    ui
  });
};

/**
 * Client-side function that checks if the application is running in a webview.
 *
 * A UI string is considered valid if it matches any of the UICookiePrefix
 * values or starts with any of the UICookiePrefix values followed by an underscore.
 *
 * This is to be backwards compatible with values such as `android_abtest` or
 * `ios_abtest` that were previously used.
 *
 * @returns A boolean indicating whether the application is running in a webview.
 */
exports.getPlatform = getPlatform;
const isWebview = () => {
  return isIos() || isAndroid();
};

/**
 * Client-side function that checks if the current platform is iOS.
 * @returns {boolean} Returns true if the platform is iOS, false otherwise.
 */
exports.isWebview = isWebview;
const isIos = () => {
  const ui = (0, _cookies.load)(_cookies.Cookie.UI);
  return (0, _shared.isIos)({
    ui
  });
};

/**
 * Client-side function that checks if the current platform is Android.
 * @returns {boolean} True if the platform is Android, false otherwise.
 */
exports.isIos = isIos;
const isAndroid = () => {
  const ui = (0, _cookies.load)(_cookies.Cookie.UI);
  return (0, _shared.isAndroid)({
    ui
  });
};

/**
 * Client-side function that checks if the current platform is Tequila.
 * @returns {boolean} Returns true if the platform is Tequila, false otherwise.
 */
exports.isAndroid = isAndroid;
const isTequila = () => {
  const ui = (0, _cookies.load)(_cookies.Cookie.UI);
  return (0, _shared.isTequila)({
    ui
  });
};
exports.isTequila = isTequila;